import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { nafColor } from '@nafcore/theme';
import { breakpoints, spacing } from '@naf/theme';
import { MenuButton } from '@naf/menu-button';
import { StyledSimbaButton } from '../../MegaMenuOverlay/NavigationButtons/NavigationButtons.styles';

export const StyledMenuButton = styled(MenuButton)`
  z-index: 25;
  margin-left: ${spacing.space16} !important;
  font-size: 1rem;

  div {
    color: ${nafColor.signature.black} !important;
    font-size: 1rem;
  }

  /* This is needed to override the second div in the MenuButton component, since it does not conatin a span like the others. */
  div:nth-child(2) {
    background: ${nafColor.signature.black} !important;
  }

  span {
    background-color: ${nafColor.signature.black} !important;
  }

  @media (max-width: ${breakpoints.l}) {
    margin-left: ${spacing.space8} !important;
  }
`;

export const TopBarMobile = styled.div<{ $isMenuOpen: boolean }>`
  display: none;
  border-radius: ${spacing.space8};
  backdrop-filter: blur(7.5px);
  height: 40px;
  padding: ${spacing.space16} 0;
  transition: background 0.3s ease-out;
  margin-top: ${spacing.space12};
  position: relative;
  z-index: 9999;

  @media (max-width: ${breakpoints.l}) {
    display: flex;
    flex-direction: column;
    padding: ${spacing.space8} ${spacing.space8};
    background-color: ${({ $isMenuOpen }) => {
      if ($isMenuOpen) {
        return nafColor?.signature.yellow10 || '#FFFAEC';
      }
      return 'rgba(255, 250, 236, 0.8)';
    }};

    ${({ $isMenuOpen }) =>
      $isMenuOpen &&
      css`
        flex-direction: column;
        height: 40px;
        backdrop-filter: blur(0);
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 0;
      `};

    @media (max-width: ${breakpoints.m}) {
      ${({ $isMenuOpen }) =>
        $isMenuOpen &&
        css`
          border-radius: 0;
        `}
    }
  }
`;

export const MobileMenuButtonsWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  justify-content: flex-end;

  .naf-ButtonLabel {
    font-size: 1rem;
  }
`;

export const MobileTopBarInline = styled.div<{ $isMenuOpen: boolean }>`
  display: flex;
  height: 40px;

  @media (max-width: ${breakpoints.m}) {
    ${({ $isMenuOpen }) =>
      $isMenuOpen &&
      css`
        padding: 0 ${spacing.space16};
      `}
  }
`;

export const SearchButton = styled(StyledSimbaButton)`
  && {
    background-color: transparent;

    .naf-ButtonLabel {
      font-size: 1rem;
    }

    &:hover {
      background-color: ${nafColor.signature.yellow40};
    }
  }
`;
